import React from "react";
import RichText from 'components/RichText';
import style from "./index.module.scss";
import Utils from 'utils/utils.js';

const ArticleDetail = ({ detail }) => {
  let html = `
    <style>
      a {
        word-break: break-all;
      }
    </style>
    ${detail.bigContent || ''}
  `;

  if(Utils.getQueryVariable('k')){

   html = Utils.matchSearchKeys(html,'str')
  }

  return (
    <div className={`${style.articleDetail}`}>
      <div className={`${style.detailContent}`} id="scrollContainer">
        <div className={`${style.detailContentHeader}`}>
          <div className={`${style.title}`}>{detail.articleName}</div>
          <div className={`${style.time}`}>
            <img className={`${style.icon}`} src="https://img13.360buyimg.com/imagetools/jfs/t1/145753/13/11056/509/5f88fe57Ecbf91214/6756de39c356ca23.png" alt=""/>
            <span className={`${style.text}`}>{`最后更新日期：${detail.updateTime || ''}`}</span>
          </div>
        </div>
        <RichText className={`${style.detailContentText}`} html={html} />
        {/* <div className={`${style.detailContentText}`} dangerouslySetInnerHTML = {{ __html: detail.bigContent }} /> */}
      </div>
    </div>
  );
};

export default ArticleDetail;
